import { render, staticRenderFns } from "./UploadSetting.vue?vue&type=template&id=e857a314"
import script from "./UploadSetting.vue?vue&type=script&lang=js"
export * from "./UploadSetting.vue?vue&type=script&lang=js"
import style0 from "./UploadSetting.vue?vue&type=style&index=0&id=e857a314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports